import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card flex justify-center rounded-lg" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = { class: "text-sm" }

import { enPrimeVueTranslations } from '@/locales/primeVue/en-primevue-translations'
import { esPrimeVueTranslations } from '@/locales/primeVue/es-primevue-translations'
import { ptPrimeVueTranslations } from '@/locales/primeVue/pt-primevue-translations'
import { useLanguageStore } from '@/stores/LanguageStore'
import { Select, SelectButton } from 'primevue'
import { usePrimeVue } from 'primevue/config'
import { onMounted, ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectLanguage',
  props: {
  opacity: {
    type: Number,
    default: 1,
  },
},
  setup(__props) {



const languageStore = useLanguageStore()
const primeVue = usePrimeVue()

const selectedLanguage = ref(languageStore.locale || 'pt')

const localePrimeVue = {
  pt: ptPrimeVueTranslations,
  es: esPrimeVueTranslations,
  en: enPrimeVueTranslations,
}

const countries = ref([
  { name: 'PT', value: 'pt', flag: 'br' },
  { name: 'EN', value: 'en', flag: 'us' },
  { name: 'ES', value: 'es', flag: 'es' },
])

const changeLanguagePrimeVue = (language: (typeof languageStore.availableLocales)[number]) => {
  primeVue.config.locale = localePrimeVue[language as keyof typeof localePrimeVue]
}

watch(selectedLanguage, (newVal) => {
  languageStore.changeLanguage(newVal)
  changeLanguagePrimeVue(newVal)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SelectButton), {
      modelValue: selectedLanguage.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguage).value = $event)),
      options: countries.value,
      optionLabel: "name",
      optionValue: "value",
      "aria-labelledby": "custom",
      allowEmpty: false,
      placeholder: _unref(languageStore).t('app.language'),
      pt: {
        pcToggleButton: {
          root: {
            // class: `!bg-[rgba(241,245,249,${opacity})] !border-[rgba(241,245,249,${opacity})]`,
            style: {
              backgroundColor: `rgba(241, 245, 249, ${__props.opacity})`,
              borderColor: `rgba(241, 245, 249, ${__props.opacity})`,
            },
          },
        },
      }
    }, {
      option: _withCtx((slotProps) => [
        _createElementVNode("img", {
          alt: slotProps.option.label,
          src: `https://flagcdn.com/w80/${slotProps.option.flag}.png`,
          class: _normalizeClass(`flag mr-2`),
          style: {"width":"16px"}
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, _toDisplayString(slotProps.option.name), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "options", "placeholder", "pt"])
  ]))
}
}

})